import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import Loading from '../ui/Loading'

export default function LoginPage() {
    const { login } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const from = (location.state && location.state.from && location.state.from.pathname) || '/'

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const onSubmit = async (e) => {
        e.preventDefault()
        setError(null)
        setLoading(true)
        try {
            await login(email, password)
            navigate(from, { replace: true })
        } catch (err) {
            const msg = err?.response?.data?.error?.message || err?.response?.data?.message || err?.message || '로그인에 실패했습니다'
            setError(msg)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="min-h-[60vh] flex items-center justify-center">
            <form onSubmit={onSubmit} className="w-full max-w-sm space-y-4 p-6 border rounded-lg">
                <h1 className="text-xl font-semibold">로그인</h1>
                {error && <div className="text-red-600 text-sm">{error}</div>}
                <div>
                    <label className="block text-sm text-slate-600">이메일</label>
                    <input className="mt-1 w-full rounded border px-3 py-2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div>
                    <label className="block text-sm text-slate-600">비밀번호</label>
                    <input className="mt-1 w-full rounded border px-3 py-2" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <button className="w-full rounded bg-brand-navy text-white py-2 disabled:opacity-50" type="submit" disabled={loading}>
                    {loading ? <Loading label="로그인 중…" /> : '로그인'}
                </button>
                <div className="pt-4 text-sm text-slate-600 flex justify-between">
                    <span>초대 코드가 있으신가요? 초대 링크에서 가입해 주세요.</span>
                </div>
                <div className="text-sm text-slate-600">
                    <span>직접 가입을 원하시면 </span>
                    <Link to="/signup" className="text-brand-navy font-semibold underline">
                        회원가입 신청
                    </Link>
                    <span>을 이용해 주세요.</span>
                </div>
            </form>
        </div>
    )
}
